<template>
  <div class="answer-sheet-wrapper" :style="{ height: answerSheetVH + 'vh' }">
    <div class="answer-sheet-container">
      <div class="answer-sheet-scroll">
        <div class="answer-sheet-title">答题卡</div>
        <div v-html="data.answerSheet" />
        <div v-if="showBtn" class="btn-container">
          <van-button
            @click="onSubmit"
            round
            type="primary"
            block
            :disabled="submitDisabled"
            >完成练习</van-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: {},
    },
    answerSheetVH: {
      type: Number,
      default: 50,
    },
    showBtn: {
      type: Boolean,
      default: true,
    },
    submitDisabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onSubmit() {
      this.$emit('submit')
    }
  },
  components: {},
};
</script>

<style lang="less">
.answer-sheet-wrapper {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background: #fff;
  border-top: 1px solid #ebedf0;
  border-radius: 16px 16px 0 0;
}
.answer-sheet-container {
  height: 100%;
  padding: 0.2rem;
  .answer-sheet-title {
    font-size: .32rem;
    font-weight: bold;
    text-align: center;
  }
  .answer-sheet-scroll {
    padding: 0.1rem 0 .4rem;
    height: 100%;
    overflow-y: auto;
    overscroll-behavior: none;
  }
  input[type="text"]{
    /*width: 6rem !important;*/
    text-align: left !important;
    padding-left: .3rem;
  }
}
</style>
